import React from "react";

const EventFilter = ({ filter, activeFilter, updateFilters }) => (
    <select
        id={filter.slug}
        name={filter.slug}
        className={`event-overview__field is-select${typeof activeFilter !== "undefined" ? " is-active" : ""}`}
        value={activeFilter || ""}
        onChange={(event) => updateFilters(filter.slug, event.currentTarget.value)}
    >
        <option value="">{filter.title}</option>
        {Object.keys(filter.options).map(key => (
            <option value={filter.options[key].slug} key={filter.options[key].slug}>
                {filter.options[key].label}
            </option>
        ))}
    </select>
);

export default EventFilter;
